export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./operations-awaiting-antifraud.vue?vue&type=template&id=854d373a"


//////////////////
// WEBPACK FOOTER
// ./src/components/payment-system/operations-awaiting-antifraud.vue?vue&type=template&id=854d373a
// module id = NYDE
// module chunks = 0